import './Boton.css';

function Boton() {
    return <button type="submit" className='btn'>Guardar</button>;
}

export default Boton;